import getUser from "./user";
import getConfig from "./config";
import getDz from "./dz";
// 导出接口
export default {
  getUser,
   getConfig,
  getDz
};
